import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'header-modifica-ordine',
  templateUrl: './header-modifica-ordine.component.html',
  styleUrls: ['./header-modifica-ordine.component.scss']
})
export class HeaderModificaOrdineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
